// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { eNetworkName } from 'app/services/contract/contract.config';
import { networkSettings } from 'app/services/web3/web3.service';
import { Magic } from 'magic-sdk';

export const environment = {
    production: false,
    apiBaseUrl: /* "http://localhost:5530/" */"https://api.kryptomon.co/",
    apiBaseUrlV22: "https://api-staging-n7ni4.ondigitalocean.app/",
    allowedNetwork: [eNetworkName.chapel], //It is possible to add network allowed, but if you want to test a network add as first item
    // apiBaseUrlV22: "https://api-v22.kryptomon.co/",//Production BE
    // allowedNetwork: [eNetworkName.bsc], //It is possible to add network allowed, but if you want to test a network add as first item
    apiImages: "https://kryptomon-images.ams3.digitaloceanspaces.com/",
    nftServer: "https://nft-server-h9u8n.ondigitalocean.app/",
    coingecko: "https://api.coingecko.com/"
};



// export const contracts = {
//     contractAddress: "0xc33d69a337b796a9f0f7588169cd874c3987bde9",
//     tokenAddress: "0xc732b6586a93b6b7cf5fed3470808bc74998224d",
//     merkleClaimAddress: "0xaC511e5957a8ACA1f7A946E96268Bf84F44b5EFC",
//     merkleClaimAddress2: "0x82Fdc5A0A1eBe363EeA589f6E514E4d1b2175D26",
//     merkleClaimAddress3: "0x434Dcd4c89A65B1d844Fb3a5976D410207cD8b88",
//     merkleClaimAddress4: "0x841a2d88cDC528aABF100A0A5A386d53f6DCf8A6",
//     merkleAirdropClaimAddress: "0x2A2DdF52eFEE31083C9557603B5D126DF7096f8a", //"0x133bEE86134D346788993a4BcD9b0F2f1F30183f",
//     merkleLoreAddress: "0x1830F3E3A7806718BE9D09a586421F163802d686",
//     merkleLoreAddress2: "0xF76034aF005603cF653Bc06c37f0EBdec377DC57",
//     lotteryAddress: "0x7A16658f04c32D2df40726E3028b600D585D99A5",
//     oldLotteryAddress: "0xDDcDF8619d27cBbF12070f3B7cbE5fDe17429622",
//     rewardsAddress: "0x16108bcDC5C52a426F823FBF83aBFde763E91ABf",
//     newRewardsAddress: "0x65a168cFDA8fECbCBbF197e456099893E7f9094B",
//     newRewardsAddressLP: "0xdBb47Cc765B9656e8C18fa975662CC3EbF778548",
//     LPAddress: "0x9dFf2991f531c44CE5E484bC37589D6A18d68F5E",
//     //MetaMask #DEEPLINK ADDRESS FOR MOBILE DEVICES
//     deeplink: "https://metamask.app.link/dapp/hub.kryptomon.co/",
// }


export const apiEndPointByNetwork = {
    BinanceSmartProd: "https://api-v2.kryptomon.co",
    Rinkeby: "https://api-staging-n7ni4.ondigitalocean.app"
}

// export const magicLink = new Magic('pk_live_CA8F776F511241BA', {
//     network: environment.BSCOptions,
// });

export const magicLink = new Magic('pk_live_CA8F776F511241BA', {
    network: {
        rpcUrl: networkSettings[environment.allowedNetwork[0]].rpcUrls[0],
        chainId: parseInt(networkSettings[environment.allowedNetwork[0]].chainId, 16)//56, // Smart Chain chain id
    },
});

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
